import React from "react";
import { arrayOf, exact, number, shape, string } from "prop-types";
import { Card, Heading } from "uikit/components";
import styles from "./MunicipalityLoadingView.module.styl";
import MunicipalityBuildingLoadingRow from "components/loading/MunicipalityBuildingLoadingRow/MunicipalityBuildingLoadingRow";
import { toShortDateStringLocale } from "utils";

export default function MunicipalityLoadingView({ regionId, municipalityId, data }) {
    return (
        <>
            <Heading size={"h1"} className={styles.heading} name="municipality-loading-header">
                {data.municipalityName}: Загруженность спортивных объектов с{" "}
                {toShortDateStringLocale(data.reportDates.start)}. по{" "}
                {toShortDateStringLocale(data.reportDates.end)}.
            </Heading>
            <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
                <div className={styles.headingContainer} data-test-name="municipality_loading_view">
                    <div className={styles.buildingName}>Название спортивного объекта</div>
                    <div className={styles.loading}>Загруженность</div>
                </div>
                <div>
                    {data.sportObjectLoadings?.map((item) => (
                        <MunicipalityBuildingLoadingRow
                            key={item.id}
                            regionId={regionId}
                            municipalityId={municipalityId}
                            sportObjectLoading={item}
                        />
                    )) ?? []}
                </div>
            </Card>
        </>
    );
}

MunicipalityLoadingView.propTypes = {
    regionId: number.isRequired,
    municipalityId: number.isRequired,
    data: exact({
        reportDates: shape({
            start: string.isRequired,
            end: string.isRequired,
        }).isRequired,
        municipalityName: string.isRequired,
        sportObjectLoadings: arrayOf(
            shape({
                id: number.isRequired,
                name: string.isRequired,
                loading: number.isRequired,
            }),
        ),
    }),
};
